import { Link } from 'react-router-dom';
import './ListingCard.css';

const CONDITION_MAP = {
  new:        { label: 'New',       cls: 'badge-violet' },
  like_new:   { label: 'Like New',  cls: 'badge-cyan'   },
  good:       { label: 'Good',      cls: 'badge-cyan'   },
  fair:       { label: 'Fair',      cls: 'badge-yellow' },
  parts_only: { label: 'Parts Only',cls: 'badge-red'    },
};

const CATEGORY_MAP = {
  street_legal:  { label: 'Street Legal',  icon: 'S' },
  mini_moto:     { label: 'Mini Moto',     icon: 'M' },
  medium_moto:   { label: 'Medium Moto',   icon: 'M' },
  mega_moto:     { label: 'Mega Moto',     icon: 'X' },
  part:          { label: 'Part',          icon: 'P' },
  accessory:     { label: 'Accessory',     icon: 'A' },
};

export default function ListingCard({ listing }) {
  const cond = CONDITION_MAP[listing.condition] || { label: listing.condition, cls: 'badge-cyan' };
  const cat  = CATEGORY_MAP[listing.category]  || { label: listing.category, icon: '?' };
  const cover = listing.images?.[0];

  return (
    <Link to={`/listings/${listing.id}`} className="listing-card card">
      <div className="lc-image">
        {cover
          ? <img src={cover} alt={listing.title} loading="lazy" />
          : <div className="lc-placeholder"><span>{cat.icon}</span></div>
        }
        <div className="lc-cat-pill">{cat.label}</div>
      </div>
      <div className="lc-body">
        <h3 className="lc-title">{listing.title}</h3>
        {(listing.brand || listing.year) && (
          <p className="lc-meta mono">
            {[listing.year, listing.brand, listing.model].filter(Boolean).join(' · ')}
          </p>
        )}
        {listing.location && <p className="lc-location">{listing.location}</p>}
        <div className="lc-footer">
          <span className="lc-price mono">${Number(listing.price).toLocaleString()}</span>
          <span className={`badge ${cond.cls}`}>{cond.label}</span>
        </div>
      </div>
    </Link>
  );
}
